import { IconWrapper } from '../runtime';
export default IconWrapper('like', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5.00011 6.74971V14.2497M14.2463 7.49971L13.802 12.896C13.7286 13.6658 13.082 14.2536 12.3088 14.2536C9.8457 14.2536 7.46317 14.2536 5.00011 14.2536L4.99902 6.74969C4.99902 6.44891 5.04797 6.45036 5.18483 6.28988C6.33396 4.94253 6.57116 4.38908 7.24021 2.16503C7.4421 1.67833 7.8753 1.17169 8.34889 1.40267C9.24157 1.83802 9.75951 2.59574 9.65733 3.77407C9.58714 4.58351 9.52217 5.33266 9.45345 5.81738C9.42202 6.03906 9.61965 6.26477 9.84198 6.2384L12.8512 5.8815C12.9475 5.87861 13.0445 5.88279 13.1377 5.90741C13.8399 6.09295 14.3166 6.76275 14.2463 7.49971Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M5 6.74976H2.3C2.13431 6.74976 2 6.88407 2 7.04976V13.9498C2 14.1154 2.13431 14.2498 2.3 14.2498H5",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});